import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a263218"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wage-excel-upload" }
const _hoisted_2 = { class: "wage-info-section" }
const _hoisted_3 = { class: "wage-info-inputs" }
const _hoisted_4 = {
  class: "d-flex",
  style: {"width":"800px"}
}
const _hoisted_5 = { class: "file-upload-section" }
const _hoisted_6 = { class: "button-group" }
const _hoisted_7 = { class: "button-group" }
const _hoisted_8 = {
  key: 0,
  class: "data-preview mt-6"
}
const _hoisted_9 = { class: "preview-header" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "preview-title" }, "저장된 데이터", -1))
const _hoisted_11 = { class: "header-controls" }
const _hoisted_12 = { class: "usage-guide" }
const _hoisted_13 = {
  key: 0,
  class: "guide-text"
}
const _hoisted_14 = {
  key: 1,
  class: "guide-text"
}
const _hoisted_15 = {
  key: 2,
  class: "guide-text"
}
const _hoisted_16 = { class: "data-count" }
const _hoisted_17 = { class: "table-container" }
const _hoisted_18 = {
  key: 0,
  class: "editable-wage-table"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "이름"),
    /*#__PURE__*/_createElementVNode("th", null, "입퇴사여부"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"100px"} }, "휴대폰"),
    /*#__PURE__*/_createElementVNode("th", null, "생년월일"),
    /*#__PURE__*/_createElementVNode("th", null, "입사일"),
    /*#__PURE__*/_createElementVNode("th", null, "직책"),
    /*#__PURE__*/_createElementVNode("th", null, "기본급"),
    /*#__PURE__*/_createElementVNode("th", null, "연장수당"),
    /*#__PURE__*/_createElementVNode("th", null, "야간수당"),
    /*#__PURE__*/_createElementVNode("th", null, "휴일수당"),
    /*#__PURE__*/_createElementVNode("th", null, "연차수당"),
    /*#__PURE__*/_createElementVNode("th", null, "장기근속"),
    /*#__PURE__*/_createElementVNode("th", null, "선임수당"),
    /*#__PURE__*/_createElementVNode("th", null, "상여금"),
    /*#__PURE__*/_createElementVNode("th", null, "교육비"),
    /*#__PURE__*/_createElementVNode("th", null, "보존수당"),
    /*#__PURE__*/_createElementVNode("th", null, "기타수당"),
    /*#__PURE__*/_createElementVNode("th", null, "당직수당"),
    /*#__PURE__*/_createElementVNode("th", null, "중식대"),
    /*#__PURE__*/_createElementVNode("th", null, "차량비"),
    /*#__PURE__*/_createElementVNode("th", null, "양육비"),
    /*#__PURE__*/_createElementVNode("th", null, "임금 총액"),
    /*#__PURE__*/_createElementVNode("th", null, "국민연금"),
    /*#__PURE__*/_createElementVNode("th", null, "건강보험"),
    /*#__PURE__*/_createElementVNode("th", null, "장기요양"),
    /*#__PURE__*/_createElementVNode("th", null, "고용보험"),
    /*#__PURE__*/_createElementVNode("th", null, "실업급여"),
    /*#__PURE__*/_createElementVNode("th", null, "산재보험"),
    /*#__PURE__*/_createElementVNode("th", null, "식비공제")
  ])
], -1))
const _hoisted_20 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_21 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_22 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_23 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_24 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_25 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_26 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_27 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_28 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_29 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_30 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_31 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_32 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_33 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_34 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_35 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_36 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_37 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_38 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_39 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_40 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_41 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_42 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_43 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_44 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_45 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_46 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_47 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_48 = ["onUpdate:modelValue", "onKeydown", "data-row"]
const _hoisted_49 = { class: "sum-row" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "sum-label",
  colspan: "6"
}, "합계", -1))
const _hoisted_51 = { class: "sum-value" }
const _hoisted_52 = { class: "sum-value" }
const _hoisted_53 = { class: "sum-value" }
const _hoisted_54 = { class: "sum-value" }
const _hoisted_55 = { class: "sum-value" }
const _hoisted_56 = { class: "sum-value" }
const _hoisted_57 = { class: "sum-value" }
const _hoisted_58 = { class: "sum-value" }
const _hoisted_59 = { class: "sum-value" }
const _hoisted_60 = { class: "sum-value" }
const _hoisted_61 = { class: "sum-value" }
const _hoisted_62 = { class: "sum-value" }
const _hoisted_63 = { class: "sum-value" }
const _hoisted_64 = { class: "sum-value" }
const _hoisted_65 = { class: "sum-value" }
const _hoisted_66 = { class: "sum-value" }
const _hoisted_67 = { class: "sum-value" }
const _hoisted_68 = { class: "sum-value" }
const _hoisted_69 = { class: "sum-value" }
const _hoisted_70 = { class: "sum-value" }
const _hoisted_71 = { class: "sum-value" }
const _hoisted_72 = { class: "sum-value" }
const _hoisted_73 = { class: "sum-value" }
const _hoisted_74 = {
  key: 1,
  class: "view-wage-table"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "group-header" }, [
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "5",
      class: "group-title"
    }, "사원정보"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "16",
      class: "group-title"
    }, "임금구성"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "3",
      class: "group-title"
    }, "조정내역"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "11",
      class: "group-title"
    }, "근로자 공제"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "8",
      class: "group-title"
    }, "기관 공제")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { class: "detail-header" }, [
    /*#__PURE__*/_createElementVNode("th", null, "이름"),
    /*#__PURE__*/_createElementVNode("th", null, "입퇴사여부"),
    /*#__PURE__*/_createElementVNode("th", null, "직책"),
    /*#__PURE__*/_createElementVNode("th", null, "생년월일"),
    /*#__PURE__*/_createElementVNode("th", null, "입사일"),
    /*#__PURE__*/_createElementVNode("th", null, "기본급"),
    /*#__PURE__*/_createElementVNode("th", null, "연장수당"),
    /*#__PURE__*/_createElementVNode("th", null, "야간수당"),
    /*#__PURE__*/_createElementVNode("th", null, "휴일수당"),
    /*#__PURE__*/_createElementVNode("th", null, "연차수당"),
    /*#__PURE__*/_createElementVNode("th", null, "장기근속"),
    /*#__PURE__*/_createElementVNode("th", null, "선임수당"),
    /*#__PURE__*/_createElementVNode("th", null, "상여금"),
    /*#__PURE__*/_createElementVNode("th", null, "교육비"),
    /*#__PURE__*/_createElementVNode("th", null, "보존수당"),
    /*#__PURE__*/_createElementVNode("th", null, "기타수당"),
    /*#__PURE__*/_createElementVNode("th", null, "당직수당"),
    /*#__PURE__*/_createElementVNode("th", null, "중식대"),
    /*#__PURE__*/_createElementVNode("th", null, "차량비"),
    /*#__PURE__*/_createElementVNode("th", null, "양육비"),
    /*#__PURE__*/_createElementVNode("th", { class: "total-column" }, "임금합계"),
    /*#__PURE__*/_createElementVNode("th", null, "과세임금"),
    /*#__PURE__*/_createElementVNode("th", null, "통상임금"),
    /*#__PURE__*/_createElementVNode("th", null, "최저임금"),
    /*#__PURE__*/_createElementVNode("th", null, "연금"),
    /*#__PURE__*/_createElementVNode("th", null, "건강"),
    /*#__PURE__*/_createElementVNode("th", null, "장기"),
    /*#__PURE__*/_createElementVNode("th", null, "고용"),
    /*#__PURE__*/_createElementVNode("th", null, "소득세"),
    /*#__PURE__*/_createElementVNode("th", null, "지방세"),
    /*#__PURE__*/_createElementVNode("th", null, "지원공제"),
    /*#__PURE__*/_createElementVNode("th", null, "식비공제"),
    /*#__PURE__*/_createElementVNode("th", null, "기타공제"),
    /*#__PURE__*/_createElementVNode("th", null, "연말정산"),
    /*#__PURE__*/_createElementVNode("th", { class: "total-column" }, "합계"),
    /*#__PURE__*/_createElementVNode("th", null, "연금"),
    /*#__PURE__*/_createElementVNode("th", null, "건강"),
    /*#__PURE__*/_createElementVNode("th", null, "장기"),
    /*#__PURE__*/_createElementVNode("th", null, "고용"),
    /*#__PURE__*/_createElementVNode("th", null, "실업"),
    /*#__PURE__*/_createElementVNode("th", null, "산재"),
    /*#__PURE__*/_createElementVNode("th", null, "기타"),
    /*#__PURE__*/_createElementVNode("th", { class: "total-column" }, "합계")
  ])
], -1))
const _hoisted_76 = { class: "table-cell text-center" }
const _hoisted_77 = { class: "table-cell text-center" }
const _hoisted_78 = { class: "table-cell text-center" }
const _hoisted_79 = { class: "table-cell text-center" }
const _hoisted_80 = { class: "table-cell text-center" }
const _hoisted_81 = { class: "table-cell text-right" }
const _hoisted_82 = { class: "table-cell text-right" }
const _hoisted_83 = { class: "table-cell text-right" }
const _hoisted_84 = { class: "table-cell text-right" }
const _hoisted_85 = { class: "table-cell text-right" }
const _hoisted_86 = { class: "table-cell text-right" }
const _hoisted_87 = { class: "table-cell text-right" }
const _hoisted_88 = { class: "table-cell text-right" }
const _hoisted_89 = { class: "table-cell text-right" }
const _hoisted_90 = { class: "table-cell text-right" }
const _hoisted_91 = { class: "table-cell text-right" }
const _hoisted_92 = { class: "table-cell text-right" }
const _hoisted_93 = { class: "table-cell text-right" }
const _hoisted_94 = { class: "table-cell text-right" }
const _hoisted_95 = { class: "table-cell text-right" }
const _hoisted_96 = {
  class: "table-cell text-right",
  style: {"font-weight":"700"}
}
const _hoisted_97 = { class: "table-cell text-right" }
const _hoisted_98 = { class: "table-cell text-right" }
const _hoisted_99 = { class: "table-cell text-right" }
const _hoisted_100 = { class: "table-cell text-right" }
const _hoisted_101 = { class: "table-cell text-right" }
const _hoisted_102 = { class: "table-cell text-right" }
const _hoisted_103 = { class: "table-cell text-right" }
const _hoisted_104 = { class: "table-cell text-right" }
const _hoisted_105 = { class: "table-cell text-right" }
const _hoisted_106 = { class: "table-cell text-right" }
const _hoisted_107 = { class: "table-cell text-right" }
const _hoisted_108 = { class: "table-cell text-right" }
const _hoisted_109 = { class: "table-cell text-right" }
const _hoisted_110 = {
  class: "table-cell text-right",
  style: {"font-weight":"700"}
}
const _hoisted_111 = { class: "table-cell text-right" }
const _hoisted_112 = { class: "table-cell text-right" }
const _hoisted_113 = { class: "table-cell text-right" }
const _hoisted_114 = { class: "table-cell text-right" }
const _hoisted_115 = { class: "table-cell text-right" }
const _hoisted_116 = { class: "table-cell text-right" }
const _hoisted_117 = { class: "table-cell text-right" }
const _hoisted_118 = {
  class: "table-cell text-right",
  style: {"font-weight":"700"}
}
const _hoisted_119 = { class: "sum-row" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "sum-label",
  colspan: "5"
}, "합계", -1))
const _hoisted_121 = { class: "sum-value" }
const _hoisted_122 = { class: "sum-value" }
const _hoisted_123 = { class: "sum-value" }
const _hoisted_124 = { class: "sum-value" }
const _hoisted_125 = { class: "sum-value" }
const _hoisted_126 = { class: "sum-value" }
const _hoisted_127 = { class: "sum-value" }
const _hoisted_128 = { class: "sum-value" }
const _hoisted_129 = { class: "sum-value" }
const _hoisted_130 = { class: "sum-value" }
const _hoisted_131 = { class: "sum-value" }
const _hoisted_132 = { class: "sum-value" }
const _hoisted_133 = { class: "sum-value" }
const _hoisted_134 = { class: "sum-value" }
const _hoisted_135 = { class: "sum-value" }
const _hoisted_136 = {
  class: "sum-value",
  style: {"font-weight":"700"}
}
const _hoisted_137 = { class: "sum-value" }
const _hoisted_138 = { class: "sum-value" }
const _hoisted_139 = { class: "sum-value" }
const _hoisted_140 = { class: "sum-value" }
const _hoisted_141 = { class: "sum-value" }
const _hoisted_142 = { class: "sum-value" }
const _hoisted_143 = { class: "sum-value" }
const _hoisted_144 = { class: "sum-value" }
const _hoisted_145 = { class: "sum-value" }
const _hoisted_146 = { class: "sum-value" }
const _hoisted_147 = { class: "sum-value" }
const _hoisted_148 = { class: "sum-value" }
const _hoisted_149 = { class: "sum-value" }
const _hoisted_150 = {
  class: "sum-value",
  style: {"font-weight":"700"}
}
const _hoisted_151 = { class: "sum-value" }
const _hoisted_152 = { class: "sum-value" }
const _hoisted_153 = { class: "sum-value" }
const _hoisted_154 = { class: "sum-value" }
const _hoisted_155 = { class: "sum-value" }
const _hoisted_156 = { class: "sum-value" }
const _hoisted_157 = { class: "sum-value" }
const _hoisted_158 = {
  class: "sum-value",
  style: {"font-weight":"700"}
}

import axios from 'axios';
import { computed, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import * as XLSX from 'xlsx';
import FormatMonth from '../../../components/admin/common/datePicker/FormatMonth.vue'
import AligoSMS from '../../../components/api/AligoSMS.vue';
import WageTransaction from '../../../components/admin/wage/WageTransaction.vue';
import WageExcelBeforeAfter from '../../../components/admin/wage/WageExcelBeforeAfter.vue';
import WageBeforeAfterYearly from '../../../components/admin/wage/WageBeforeAfterYearly.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WageExcelUp',
  setup(__props) {

const store = useStore();

const sisulName = ref<string>(store.state.AdminSisulName);

// 반응형 데이터
const selectedFile = ref<File[]>([]);
const isUploading = ref(false);
const isGenerating = ref(false);
const excelData = ref<any[]>([]);
const calcData = ref<any[]>([]);
const paymentDate = ref('');
const tableViewMode = ref<'edit' | 'view'>('edit');
const isAdjustmentApplied = ref(false); // 공제조정 엑셀 업로드 적용 상태
const isRetirementUpdating = ref(false); // 퇴직금 중식대 옵션 업데이트 로딩 상태

// 퇴직금 중식대 포함 여부 (excelData의 첫 번째 항목에서 확인)
const isRetireLunchIncluded = computed(() => {
  if (!excelData.value || excelData.value.length === 0) return false;
  const firstItem = excelData.value[0];
  return firstItem.retireLunchInclude === 1 || firstItem.retireLunchInclude === '1';
});

// 파일 선택 핸들러
const handleFileSelect = (files: File[]) => {
  selectedFile.value = files;
};

// 엑셀 업로드 - 백엔드 API 호출
const uploadExcel = async () => {
  if (!selectedFile.value || selectedFile.value.length === 0) {
    store.commit('showSnackbar', {
      text: "파일을 선택해주세요.",
      color: "warning"
    });
    return;
  }

  if (!paymentDate.value) {
    store.commit('showSnackbar', {
      text: "지급일을 입력해주세요.",
      color: "warning"
    });
    return;
  }

  isUploading.value = true;

  try {
    const formData = new FormData();
    formData.append('excelFile', selectedFile.value[0]);
    formData.append('wageMonth', store.state.AdminYYMM);
    formData.append('paymentDate', paymentDate.value);
    formData.append('sisulName', sisulName.value);

    const response = await axios.post(`/api/uploadWageExcel/${store.state.AdminSisulCode}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    if (response.data.success) {
      excelData.value = response.data.data;

      store.commit('showSnackbar', {
        text: response.data.message,
        color: "success"
      });

      // 파일 선택 인풋 비우기
      selectedFile.value = [];

      // 업로드 후 조회 테이블 데이터도 함께 업데이트
      await getWageExcelUploadData();
    } else {
      store.commit('showSnackbar', {
        text: response.data.message,
        color: "error"
      });
    }

  } catch (error) {
    console.error('엑셀 업로드 중 오류:', error);
    store.commit('showSnackbar', {
      text: "엑셀 업로드 중 오류가 발생했습니다.",
      color: "error"
    });
  } finally {
    isUploading.value = false;
  }
};

// 엑셀 양식 다운로드
const downloadTemplate = (fileName: string) => {
  window.location.href = `/api/downloadTemplateExcel/${fileName}`;
};
const getWageExcelUploadData = async () => {
  try {
    // 데이터 재조회 시 공제조정 적용 상태 초기화
    isAdjustmentApplied.value = false;
    
    const response = await axios.get(`/api/getWageExcelUploadData/${store.state.AdminSisulCode}/${store.state.AdminYYMM}`);
    const responseData = response.data;
    // 컨트롤러 응답 구조: { success: boolean, result?: array, message?: string }
    if (responseData.success && responseData.excelData) {
      // 응답 데이터가 배열인지 확인하고 안전하게 할당
      if (Array.isArray(responseData.excelData)) {
        excelData.value = responseData.excelData;
        calcData.value = responseData.calcData;
        store.commit('showSnackbar', {
          text: `임금 데이터를 성공적으로 로드했습니다. (${responseData.excelData.length}건)`,
          color: "success"
        });
      } else {
        excelData.value = [];
        store.commit('showSnackbar', {
          text: "임금 데이터 형식이 올바르지 않습니다.",
          color: "warning"
        });
      }
      return responseData;
    } else {
      // success가 false이거나 데이터가 없는 경우
      excelData.value = [];
      const message = responseData.message || "임금 데이터가 없습니다.";
      store.commit('showSnackbar', {
        text: message,
        color: "info"
      });
    }
  } catch (error) {
    console.error("임금 데이터 조회 오류:", error);
    // 오류 발생 시 빈 배열로 초기화
    excelData.value = [];

    store.commit('showSnackbar', {
      text: "임금 데이터 조회 중 오류가 발생했습니다.",
      color: "error"
    });
  }
};
watch(
  () => store.state.AdminYYMM,
  (newValue) => {
    if (newValue) {
      getWageExcelUploadData();
    }
  }
);
onMounted(async () => {
  await getWageExcelUploadData();
  const now = new Date().toISOString().split('T')[0];
  paymentDate.value = now;
})

const makeWageExcel = async (type: string) => {
  // 데이터 유효성 검사
  if (!excelData.value || excelData.value.length === 0) {
    store.commit('showSnackbar', {
      text: "생성할 임금 데이터가 없습니다. 먼저 엑셀을 업로드하거나 데이터를 조회해주세요.",
      color: "warning"
    });
    return;
  }

  if (!paymentDate.value) {
    store.commit('showSnackbar', {
      text: "지급일을 입력해주세요.",
      color: "warning"
    });
    return;
  }

  try {
    isGenerating.value = true;

    // 공제조정 적용 여부에 따라 다른 API 호출
    const apiUrl = isAdjustmentApplied.value 
      ? '/api/makeWageExcelWithAdjustment' 
      : '/api/makeWageExcel';

    const requestData: any = {
      excelData: excelData.value,
      wageMonth: store.state.AdminYYMM,
      bizGubun: store.state.AdminBizGubun,
      paymentDate: paymentDate.value,
      sisulName: sisulName.value,
      type: type
    };

    // 공제조정 적용된 경우 calcData도 함께 전송
    if (isAdjustmentApplied.value) {
      requestData.calcData = calcData.value;
    }

    const response = await axios.post(apiUrl, requestData, {
      responseType: 'blob'
    });

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${type === 'fnA' ? '회계처리용' : '고객용'}_임금대장_${store.state.AdminYYMM}.xlsx`;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    store.commit('showSnackbar', {
      text: "임금대장 엑셀 파일이 성공적으로 다운로드되었습니다.",
      color: "success"
    });

  } catch (error) {
    console.error('임금대장 출력 중 오류:', error);
    store.commit('showSnackbar', {
      text: "임금대장 출력 중 오류가 발생했습니다.",
      color: "error"
    });
  } finally {
    isGenerating.value = false;
  }
}

const getWagePdfExcelUploadData = async () => {
  try {
    if (!paymentDate.value) {
      store.commit('showSnackbar', {
        text: "지급일을 입력해주세요.",
        color: "warning"
      });
      return;
    }

    // 공제조정 적용 여부에 따라 다른 API 호출
    const apiUrl = isAdjustmentApplied.value 
      ? "/api/getWagePdfExcelUploadDataWithAdjustment"
      : "/api/getWagePdfExcelUploadData";

    const requestData: any = {
      wageList: excelData.value,
      wageMonth: store.state.AdminYYMM,
      paymentDate: paymentDate.value
    };

    // 공제조정 적용된 경우 calcData도 함께 전송
    if (isAdjustmentApplied.value) {
      requestData.calcData = calcData.value;
    }

    // 서버로부터 PDF 데이터를 요청
    const response = await axios.post(
      apiUrl,
      requestData,
      {
        responseType: "json",
      }
    );

    // 서버로부터 받은 데이터에서 PDF Base64 문자열 추출
    const pdfBase64 = response.data.pdf;

    // Base64 문자열을 이진 데이터로 변환
    const binaryString = window.atob(pdfBase64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    // 이진 데이터로부터 Blob 생성
    const blob = new Blob([bytes], { type: "application/pdf" });

    // Blob URL 생성
    const url = window.URL.createObjectURL(blob);

    // 새 창에서 PDF 열기
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
      newWindow.focus();
    } else {
      console.error("새 창을 열 수 없습니다. 팝업 차단 설정을 확인하세요.");
    }
  } catch (error) {
    console.error("PDF 미리보기 중 에러 발생:", error);
  }
};
const aligoSmsRef = ref();
const adjustmentFileInput = ref<HTMLInputElement | null>(null);
const wageExcelBeforeAfterRef = ref();
const wageBeforeAfterYearlyRef = ref();

const openSmsDialog = () => {
  aligoSmsRef.value?.openDialog(calcData.value);
};

const openBeforeAfterDialog = () => {
  wageExcelBeforeAfterRef.value?.openDialog();
};

const openYearlyBeforeAfterDialog = () => {
  wageBeforeAfterYearlyRef.value?.openDialog();
};

// 공제조정 파일 인풋 트리거
const triggerAdjustmentFileInput = () => {
  adjustmentFileInput.value?.click();
};

// 공제조정 양식 다운로드 (현재 calcData 기반)
const downloadAdjustmentTemplate = () => {
  if (!calcData.value || calcData.value.length === 0) {
    store.commit('showSnackbar', {
      text: "다운로드할 데이터가 없습니다.",
      color: "warning"
    });
    return;
  }

  // 양식에 포함할 컬럼 정의 (l_so, l_ji, c_out 제외)
  const headers = [
    '이름', '연금(근로자)', '건강(근로자)', '장기(근로자)', '고용(근로자)', 
    '지원공제', '식비공제', '기타공제', '연말정산',
    '연금(기관)', '건강(기관)', '장기(기관)', '고용(기관)', '실업(기관)', '산재(기관)'
  ];

  // 이름만 채우고 나머지는 0으로 설정
  const excelRows = [headers];
  
  calcData.value.forEach((item: any) => {
    const row = [
      item.empName || '',
      0, 0, 0, 0,  // 연금, 건강, 장기, 고용 (근로자)
      0, 0, 0, 0,  // 지원공제, 식비공제, 기타공제, 연말정산
      0, 0, 0, 0, 0, 0  // 연금, 건강, 장기, 고용, 실업, 산재 (기관)
    ];
    excelRows.push(row);
  });

  // xlsx 워크북 생성
  const ws = XLSX.utils.aoa_to_sheet(excelRows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, '공제조정');

  // 컬럼 너비 설정
  ws['!cols'] = [
    { wch: 10 }, // 이름
    { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 12 }, // 근로자 공제
    { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, // 지원, 식비, 기타, 연말정산
    { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 12 } // 기관 공제
  ];

  // 파일 다운로드
  XLSX.writeFile(wb, `공제조정양식_${store.state.AdminYYMM}.xlsx`);

  store.commit('showSnackbar', {
    text: "공제조정 양식이 다운로드되었습니다.",
    color: "success"
  });
};

// 공제조정 엑셀 업로드 처리 (calcData 임시 변경, DB 저장 X)
const handleAdjustmentFileUpload = async (event: Event) => {
  const target = event.target as HTMLInputElement;
  const file = target.files?.[0];
  
  if (!file) return;

  try {
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];
    const jsonData = XLSX.utils.sheet_to_json(worksheet) as any[];

    if (jsonData.length === 0) {
      store.commit('showSnackbar', {
        text: "업로드된 엑셀에 데이터가 없습니다.",
        color: "warning"
      });
      return;
    }

    // calcData 업데이트 (이름으로 매칭)
    let updatedCount = 0;
    
    jsonData.forEach((row: any) => {
      const empName = row['이름'];
      if (!empName) return;

      const targetItem = calcData.value.find((item: any) => item.empName === empName);
      if (targetItem) {
        // 근로자 공제 항목 업데이트
        targetItem.l_yeon = formatNumberValue(row['연금(근로자)']);
        targetItem.l_gun = formatNumberValue(row['건강(근로자)']);
        targetItem.l_jang = formatNumberValue(row['장기(근로자)']);
        targetItem.l_go = formatNumberValue(row['고용(근로자)']);
        targetItem.l_jiwon = formatNumberValue(row['지원공제']);
        targetItem.l_sik = formatNumberValue(row['식비공제']);
        targetItem.l_etc = formatNumberValue(row['기타공제']);
        targetItem.l_yearEnd = formatNumberValue(row['연말정산']);
        
        // 기관 공제 항목 업데이트
        targetItem.c_yeon = formatNumberValue(row['연금(기관)']);
        targetItem.c_gun = formatNumberValue(row['건강(기관)']);
        targetItem.c_jang = formatNumberValue(row['장기(기관)']);
        targetItem.c_go = formatNumberValue(row['고용(기관)']);
        targetItem.c_sil = formatNumberValue(row['실업(기관)']);
        targetItem.c_san = formatNumberValue(row['산재(기관)']);

        // l_total 재계산 (l_so, l_ji 포함)
        const newLTotal = 
          parseNumber(targetItem.l_yeon) + parseNumber(targetItem.l_gun) + 
          parseNumber(targetItem.l_jang) + parseNumber(targetItem.l_go) +
          parseNumber(targetItem.l_so) + parseNumber(targetItem.l_ji) +
          parseNumber(targetItem.l_jiwon) + parseNumber(targetItem.l_sik) + 
          parseNumber(targetItem.l_etc) + parseNumber(targetItem.l_yearEnd);
        targetItem.l_total = formatNumberValue(newLTotal);

        // c_total 재계산 (c_out 포함)
        const newCTotal = 
          parseNumber(targetItem.c_yeon) + parseNumber(targetItem.c_gun) + 
          parseNumber(targetItem.c_jang) + parseNumber(targetItem.c_go) +
          parseNumber(targetItem.c_sil) + parseNumber(targetItem.c_san) +
          parseNumber(targetItem.c_out);
        targetItem.c_total = formatNumberValue(newCTotal);

        // 실지급액 재계산 (임금총액 - 근로자공제합계)
        const total = parseNumber(targetItem.total);
        targetItem.realMoney = formatNumberValue(total - newLTotal);

        updatedCount++;
      }
    });

    // 파일 인풋 초기화
    target.value = '';

    if (updatedCount > 0) {
      // 공제조정 적용 상태값 설정
      isAdjustmentApplied.value = true;
      
      // 조회 테이블로 자동 전환
      tableViewMode.value = 'view';
      
      store.commit('showSnackbar', {
        text: `공제조정이 임시 적용되었습니다. (${updatedCount}건) - DB에 저장되지 않습니다.`,
        color: "success"
      });
    } else {
      store.commit('showSnackbar', {
        text: "매칭되는 이름이 없어 업데이트할 데이터가 없습니다.",
        color: "warning"
      });
    }

  } catch (error) {
    console.error('공제조정 엑셀 업로드 중 오류:', error);
    store.commit('showSnackbar', {
      text: "공제조정 엑셀 업로드 중 오류가 발생했습니다.",
      color: "error"
    });
  }
};

// 숫자 파싱 헬퍼 함수
const parseNumber = (value: any): number => {
  if (value === null || value === undefined || value === '') return 0;
  const num = parseFloat(value.toString().replace(/,/g, ''));
  return isNaN(num) ? 0 : num;
};

// 숫자 포맷 헬퍼 함수
const formatNumberValue = (value: any): string => {
  const num = parseNumber(value);
  return new Intl.NumberFormat('ko-KR').format(num);
};

// 공제조정 초기화 (원래 계산값으로 복원)
const resetAdjustment = async () => {
  isAdjustmentApplied.value = false;
  await getWageExcelUploadData();
  store.commit('showSnackbar', {
    text: "공제조정이 초기화되었습니다.",
    color: "info"
  });
};

const handleKeyDown = (event: KeyboardEvent, row: number, col: number) => {
  // Ctrl+Enter로 전체 저장
  if (event.ctrlKey && event.key === 'Enter') {
    event.preventDefault();
    saveAllData();
    return;
  }

  // 방향키 이동
  if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
    event.preventDefault();

    const totalCols = 28; // 총 컬럼 수 (27->28로 변경)
    const totalRows = excelData.value.length;

    let newRow = row;
    let newCol = col;

    switch (event.key) {
      case 'ArrowUp':
        newRow = Math.max(0, row - 1);
        break;
      case 'ArrowDown':
        newRow = Math.min(totalRows - 1, row + 1);
        break;
      case 'ArrowLeft':
        newCol = Math.max(0, col - 1);
        break;
      case 'ArrowRight':
        newCol = Math.min(totalCols - 1, col + 1);
        break;
    }

    // 새로운 셀로 포커스 이동
    const nextInput = document.querySelector(`input[data-row="${newRow}"][data-col="${newCol}"]`) as HTMLInputElement;
    if (nextInput) {
      nextInput.focus();
    }
  }
};

// 전체 데이터 저장
const saveAllData = async () => {
  if (!excelData.value || excelData.value.length === 0) {
    store.commit('showSnackbar', {
      text: "저장할 데이터가 없습니다.",
      color: "warning"
    });
    return;
  }

  try {
    const response = await axios.post('/api/updateWageExcelUploadData', {
      excelData: excelData.value
    });

    if (response.data.success) {
      store.commit('showSnackbar', {
        text: response.data.message,
        color: "success"
      });
    } else {
      store.commit('showSnackbar', {
        text: response.data.message,
        color: "error"
      });
    }
    await getWageExcelUploadData();
  } catch (error) {
    console.error('전체 데이터 저장 중 오류:', error);
    store.commit('showSnackbar', {
      text: "전체 데이터 저장 중 오류가 발생했습니다.",
      color: "error"
    });
  }
};

const downloadExcelData = async () => {
  try {
    if (!excelData.value || excelData.value.length === 0) {
      store.commit('showSnackbar', {
        text: "다운로드할 데이터가 없습니다.",
        color: "warning"
      });
      return;
    }

    // 엑셀 헤더 정의
    const headers = [
      '이름', '입퇴사여부', '휴대폰', '생년월일', '입사일', '직책',
      '기본급', '연장수당', '야간수당', '휴일수당', '연차수당', '장기근속',
      '선임수당', '상여금', '교육비', '보존수당', '기타수당', '당직수당',
      '중식대', '차량비', '양육비', '임금 총액', '국민연금', '건강보험', '고용보험',
      '실업급여', '산재보험', '식비공제'
    ];

    // 데이터를 배열 형태로 변환
    const excelRows = [headers];

    excelData.value.forEach(item => {
      const row = [
        item.empName || '',
        item.empInOutStatus || '',
        item.empPhone || '',
        item.birthDate || '',
        item.empInYm || '',
        item.empJob || '',
        item.base || '',
        item.overtime || '',
        item.night || '',
        item.holiday || '',
        item.dayOffPay || '',
        item.longTerm || '',
        item.sunim || '',
        item.bonus || '',
        item.eduPay || '',
        item.bojon || '',
        item.etc || '',
        item.dang || '',
        item.lunch || '',
        item.car || '',
        item.childcare || '',
        item.total || '',
        item.yeon || '',
        item.gun || '',
        item.jang || '',
        item.go || '',
        item.sil || '',
        item.san || '',
        item.sik || ''
      ];
      excelRows.push(row);
    });

    // CSV 형태로 변환하여 다운로드
    const csvContent = excelRows.map(row =>
      row.map(cell => `"${cell}"`).join(',')
    ).join('\n');

    const blob = new Blob(['\uFEFF' + csvContent], {
      type: 'text/csv;charset=utf-8;'
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `임금데이터_${store.state.AdminYYMM}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    store.commit('showSnackbar', {
      text: "임금 데이터가 성공적으로 다운로드되었습니다.",
      color: "success"
    });
  } catch (error) {
    console.error('임금 데이터 다운로드 중 오류:', error);
    store.commit('showSnackbar', {
      text: "임금 데이터 다운로드 중 오류가 발생했습니다.",
      color: "error"
    });
  }
};

// 합산 계산 함수
const calculateSum = (field: string): number => {
  if (!excelData.value || excelData.value.length === 0) {
    return 0;
  }

  return excelData.value.reduce((sum, item) => {
    const value = parseFloat(item[field]) || 0;
    return sum + value;
  }, 0);
};

// 숫자 포맷팅 함수
const formatNumber = (value: number): string => {
  return new Intl.NumberFormat('ko-KR').format(value);
};

// 합산 계산 함수 (calcData 기반)
const calculateSumFromCalcData = (field: string): number => {
  if (!calcData.value || calcData.value.length === 0) {
    return 0;
  }

  return calcData.value.reduce((sum, item) => {
    const value = parseFloat(item[field]?.toString().replace(/,/g, '') || '0');
    return sum + value;
  }, 0);
};

// 중식대를 식비공제로 복사하는 함수
const copyLunchToFoodDeduction = async () => {
  if (!excelData.value || excelData.value.length === 0) {
    store.commit('showSnackbar', {
      text: "복사할 데이터가 없습니다.",
      color: "warning"
    });
    return;
  }

  try {
    // 모든 데이터의 중식대 값을 식비공제로 복사
    excelData.value.forEach((item: any) => {
      if (item.lunch) {
        item.sik = item.lunch;
      }
    });

    // 변경된 데이터를 서버에 저장
    const response = await axios.post('/api/updateWageExcelUploadData', {
      excelData: excelData.value
    });

    if (response.data.success) {
      store.commit('showSnackbar', {
        text: "중식대 금액이 식비공제로 성공적으로 복사되었습니다.",
        color: "success"
      });
      
      // 조회 테이블 데이터도 업데이트
      await getWageExcelUploadData();
    } else {
      store.commit('showSnackbar', {
        text: response.data.message || "데이터 저장 중 오류가 발생했습니다.",
        color: "error"
      });
    }
  } catch (error) {
    console.error('중식대→식비공제 복사 중 오류:', error);
    store.commit('showSnackbar', {
      text: "중식대→식비공제 복사 중 오류가 발생했습니다.",
      color: "error"
    });
  }
};

// 퇴직금 중식대 포함/미포함 옵션 업데이트
// 퇴직금 중식대 포함/미포함 토글
const toggleRetirementLunch = async () => {
  if (!excelData.value || excelData.value.length === 0) {
    store.commit('showSnackbar', {
      text: "업데이트할 데이터가 없습니다.",
      color: "warning"
    });
    return;
  }

  try {
    isRetirementUpdating.value = true;
    
    // 현재 상태의 반대로 토글
    const newIncludeLunch = !isRetireLunchIncluded.value;

    const response = await axios.post('/api/updateRetirementLunchOption', {
      sisulCode: store.state.AdminSisulCode,
      wageMonth: store.state.AdminYYMM,
      includeLunch: newIncludeLunch
    });

    if (response.data.success) {
      store.commit('showSnackbar', {
        text: response.data.message,
        color: "success"
      });
      
      // 조회 테이블 데이터 업데이트 (wageExcelUpCalc에서 옵션에 따라 재계산됨)
      await getWageExcelUploadData();
    } else {
      store.commit('showSnackbar', {
        text: response.data.message || "업데이트 중 오류가 발생했습니다.",
        color: "error"
      });
    }
  } catch (error) {
    console.error('퇴직금 중식대 옵션 업데이트 중 오류:', error);
    store.commit('showSnackbar', {
      text: "퇴직금 중식대 옵션 업데이트 중 오류가 발생했습니다.",
      color: "error"
    });
  } finally {
    isRetirementUpdating.value = false;
  }
};


return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, { class: "upload-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_divider, { class: "my-1" }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(FormatMonth),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_v_text_field, {
                    modelValue: paymentDate.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((paymentDate).value = $event)),
                    label: "지급일",
                    placeholder: "YYYY-MM-DD",
                    variant: "outlined",
                    "prepend-icon": "mdi-calendar",
                    type: "date",
                    density: "compact",
                    class: "payment-date-input mr-6",
                    "hide-details": ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_file_input, {
                    modelValue: selectedFile.value,
                    "onUpdate:modelValue": [
                      _cache[1] || (_cache[1] = ($event: any) => ((selectedFile).value = $event)),
                      handleFileSelect
                    ],
                    label: "엑셀 파일 선택",
                    accept: ".xlsx,.xls",
                    "prepend-icon": "mdi-file-excel",
                    variant: "outlined",
                    loading: isUploading.value,
                    "hide-details": "",
                    density: "compact"
                  }, null, 8, ["modelValue", "loading"]),
                  _createVNode(_component_v_btn, {
                    onClick: uploadExcel,
                    disabled: !selectedFile.value || selectedFile.value.length === 0 || isUploading.value,
                    color: "primary",
                    loading: isUploading.value,
                    "prepend-icon": "mdi-upload",
                    class: "ml-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 엑셀 업로드 ")
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading"])
                ])
              ])
            ]),
            _createVNode(_component_v_divider, { class: "my-1" }),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_v_menu, null, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn, _mergeProps(props, {
                      color: "primary",
                      "prepend-icon": "mdi-file-excel",
                      class: "mr-1"
                    }), {
                      default: _withCtx(() => [
                        _createTextVNode(" 엑셀 관리 "),
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-chevron-down")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1040)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item, {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (downloadTemplate('임금엑셀업로드양식.xlsx')))
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [
                                _createTextVNode("mdi-file-download")
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode("엑셀 양식 다운로드")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (excelData.value.length > 0)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 0,
                              onClick: downloadExcelData
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("mdi-file-excel-outline")
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("데이터 엑셀 다운로드")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (calcData.value.length > 0)
                          ? (_openBlock(), _createBlock(_component_v_divider, {
                              key: 1,
                              class: "my-1"
                            }))
                          : _createCommentVNode("", true),
                        (calcData.value.length > 0)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 2,
                              onClick: downloadAdjustmentTemplate
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_icon, { color: "orange" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("mdi-file-edit")
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("공제조정 양식 다운로드")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (calcData.value.length > 0)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 3,
                              onClick: triggerAdjustmentFileInput
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_icon, { color: "orange" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("mdi-file-upload")
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("공제조정 엑셀 업로드")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (excelData.value.length > 0)
                  ? (_openBlock(), _createBlock(_component_v_menu, { key: 0 }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps(props, {
                          color: "success",
                          "prepend-icon": "mdi-file-document",
                          class: "mr-1",
                          loading: isGenerating.value,
                          disabled: isGenerating.value
                        }), {
                          default: _withCtx(() => [
                            _createTextVNode(" 임금 문서 생성 "),
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [
                                _createTextVNode("mdi-chevron-down")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1040, ["loading", "disabled"])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item, {
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (makeWageExcel('admin')))
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("mdi-file-excel")
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("고객용 임금대장")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_list_item, {
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (makeWageExcel('fnA')))
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("mdi-file-excel")
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("회계처리용 임금대장")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_list_item, { onClick: getWagePdfExcelUploadData }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("mdi-file")
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("임금명세서")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                (excelData.value.length > 0)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      variant: "outlined",
                      color: "orange",
                      "prepend-icon": "mdi-mail",
                      onClick: openSmsDialog
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 임금명세서 발송 ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(WageTransaction, {
                  hasData: excelData.value.length > 0,
                  dataCount: excelData.value.length
                }, null, 8, ["hasData", "dataCount"]),
                (calcData.value.length > 0)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      variant: "outlined",
                      color: "indigo",
                      "prepend-icon": "mdi-compare",
                      onClick: openBeforeAfterDialog,
                      class: "ml-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 비과세 적용 효과 ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_btn, {
                  variant: "outlined",
                  color: "deep-purple",
                  "prepend-icon": "mdi-calendar-range",
                  onClick: openYearlyBeforeAfterDialog,
                  class: "ml-1"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 1년치 비교 ")
                  ]),
                  _: 1
                })
              ]),
              _createVNode(WageExcelBeforeAfter, {
                ref_key: "wageExcelBeforeAfterRef",
                ref: wageExcelBeforeAfterRef,
                excelData: excelData.value,
                calcData: calcData.value
              }, null, 8, ["excelData", "calcData"]),
              _createVNode(WageBeforeAfterYearly, {
                ref_key: "wageBeforeAfterYearlyRef",
                ref: wageBeforeAfterYearlyRef
              }, null, 512),
              _createVNode(AligoSMS, {
                ref_key: "aligoSmsRef",
                ref: aligoSmsRef
              }, null, 512),
              _createElementVNode("input", {
                type: "file",
                ref_key: "adjustmentFileInput",
                ref: adjustmentFileInput,
                accept: ".xlsx,.xls",
                style: {"display":"none"},
                onChange: handleAdjustmentFileUpload
              }, null, 544)
            ]),
            _createVNode(_component_v_divider, { class: "my-1" }),
            (excelData.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createVNode(_component_v_btn_toggle, {
                      modelValue: tableViewMode.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((tableViewMode).value = $event)),
                      color: "primary",
                      density: "compact",
                      variant: "outlined"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          value: "edit",
                          size: "small",
                          "prepend-icon": "mdi-table-edit"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 편집 테이블 ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          value: "view",
                          size: "small",
                          "prepend-icon": "mdi-table"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 조회 테이블 ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_v_btn, {
                      onClick: copyLunchToFoodDeduction,
                      color: "purple",
                      size: "small",
                      variant: "outlined",
                      class: "ml-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 중식대 = 식비공제 ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      onClick: toggleRetirementLunch,
                      color: isRetireLunchIncluded.value ? 'teal' : 'brown',
                      size: "small",
                      variant: isRetireLunchIncluded.value ? 'flat' : 'outlined',
                      class: "ml-2",
                      loading: isRetirementUpdating.value,
                      "prepend-icon": isRetireLunchIncluded.value ? 'mdi-check-circle' : 'mdi-close-circle'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 퇴직금 중식대 " + _toDisplayString(isRetireLunchIncluded.value ? '포함' : '미포함'), 1)
                      ]),
                      _: 1
                    }, 8, ["color", "variant", "loading", "prepend-icon"]),
                    (isAdjustmentApplied.value)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 0,
                          color: "orange",
                          variant: "flat",
                          size: "small",
                          class: "ml-2",
                          closable: "",
                          "onClick:close": resetAdjustment
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 🔧 공제조정 적용됨 ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_spacer),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        (tableViewMode.value === 'edit')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, "💡 조작방법: 셀 안에서 방향키(↑↓←→)로 셀 이동"))
                          : _createCommentVNode("", true),
                        (tableViewMode.value === 'edit')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, "💾 저장방법: 셀 안에서 Ctrl + Enter로 전체 저장"))
                          : _createCommentVNode("", true),
                        (tableViewMode.value === 'view')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, "👀 조회 모드: 데이터를 읽기 전용으로 확인할 수 있습니다"))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, "총 " + _toDisplayString(excelData.value.length) + "개의 데이터가 저장되었습니다.", 1),
                  _createElementVNode("div", _hoisted_17, [
                    (tableViewMode.value === 'edit')
                      ? (_openBlock(), _createElementBlock("table", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(excelData.value, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: index,
                                class: "view-wage-table-tr"
                              }, [
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.empName) = $event),
                                    class: "table-input text-center",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 0)),
                                    "data-row": index,
                                    "data-col": 0,
                                    maxlength: "10"
                                  }, null, 40, _hoisted_20), [
                                    [_vModelText, item.empName]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.empInOutStatus) = $event),
                                    class: "table-input text-center",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 1)),
                                    "data-row": index,
                                    "data-col": 1,
                                    maxlength: "10"
                                  }, null, 40, _hoisted_21), [
                                    [_vModelText, item.empInOutStatus]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.empPhone) = $event),
                                    class: "table-input text-center",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 2)),
                                    "data-row": index,
                                    "data-col": 2
                                  }, null, 40, _hoisted_22), [
                                    [_vModelText, item.empPhone]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.birthDate) = $event),
                                    class: "table-input text-center",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 3)),
                                    "data-row": index,
                                    "data-col": 3
                                  }, null, 40, _hoisted_23), [
                                    [_vModelText, item.birthDate]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.empInYm) = $event),
                                    class: "table-input text-center",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 4)),
                                    "data-row": index,
                                    "data-col": 4
                                  }, null, 40, _hoisted_24), [
                                    [_vModelText, item.empInYm]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.empJob) = $event),
                                    class: "table-input text-center",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 5)),
                                    "data-row": index,
                                    "data-col": 5
                                  }, null, 40, _hoisted_25), [
                                    [_vModelText, item.empJob]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.base) = $event),
                                    class: "table-input text-right",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 6)),
                                    "data-row": index,
                                    "data-col": 6
                                  }, null, 40, _hoisted_26), [
                                    [_vModelText, item.base]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.overtime) = $event),
                                    class: "table-input text-right",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 7)),
                                    "data-row": index,
                                    "data-col": 7
                                  }, null, 40, _hoisted_27), [
                                    [_vModelText, item.overtime]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.night) = $event),
                                    class: "table-input text-right",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 8)),
                                    "data-row": index,
                                    "data-col": 8
                                  }, null, 40, _hoisted_28), [
                                    [_vModelText, item.night]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.holiday) = $event),
                                    class: "table-input text-right",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 9)),
                                    "data-row": index,
                                    "data-col": 9
                                  }, null, 40, _hoisted_29), [
                                    [_vModelText, item.holiday]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.dayOffPay) = $event),
                                    class: "table-input text-right",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 10)),
                                    "data-row": index,
                                    "data-col": 10
                                  }, null, 40, _hoisted_30), [
                                    [_vModelText, item.dayOffPay]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.longTerm) = $event),
                                    class: "table-input text-right",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 11)),
                                    "data-row": index,
                                    "data-col": 11
                                  }, null, 40, _hoisted_31), [
                                    [_vModelText, item.longTerm]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.sunim) = $event),
                                    class: "table-input text-right",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 12)),
                                    "data-row": index,
                                    "data-col": 12
                                  }, null, 40, _hoisted_32), [
                                    [_vModelText, item.sunim]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.bonus) = $event),
                                    class: "table-input text-right",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 13)),
                                    "data-row": index,
                                    "data-col": 13
                                  }, null, 40, _hoisted_33), [
                                    [_vModelText, item.bonus]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.eduPay) = $event),
                                    class: "table-input text-right",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 14)),
                                    "data-row": index,
                                    "data-col": 14
                                  }, null, 40, _hoisted_34), [
                                    [_vModelText, item.eduPay]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.bojon) = $event),
                                    class: "table-input text-right",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 15)),
                                    "data-row": index,
                                    "data-col": 15
                                  }, null, 40, _hoisted_35), [
                                    [_vModelText, item.bojon]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.etc) = $event),
                                    class: "table-input text-right",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 16)),
                                    "data-row": index,
                                    "data-col": 16
                                  }, null, 40, _hoisted_36), [
                                    [_vModelText, item.etc]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.dang) = $event),
                                    class: "table-input text-right",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 17)),
                                    "data-row": index,
                                    "data-col": 17
                                  }, null, 40, _hoisted_37), [
                                    [_vModelText, item.dang]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.lunch) = $event),
                                    class: "table-input text-right",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 18)),
                                    "data-row": index,
                                    "data-col": 18
                                  }, null, 40, _hoisted_38), [
                                    [_vModelText, item.lunch]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.car) = $event),
                                    class: "table-input text-right",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 19)),
                                    "data-row": index,
                                    "data-col": 19
                                  }, null, 40, _hoisted_39), [
                                    [_vModelText, item.car]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.childcare) = $event),
                                    class: "table-input text-right",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 20)),
                                    "data-row": index,
                                    "data-col": 20
                                  }, null, 40, _hoisted_40), [
                                    [_vModelText, item.childcare]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.total) = $event),
                                    class: "table-input text-right",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 21)),
                                    "data-row": index,
                                    "data-col": 21
                                  }, null, 40, _hoisted_41), [
                                    [_vModelText, item.total]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.yeon) = $event),
                                    class: "table-input text-right",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 22)),
                                    "data-row": index,
                                    "data-col": 22
                                  }, null, 40, _hoisted_42), [
                                    [_vModelText, item.yeon]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.gun) = $event),
                                    class: "table-input text-right",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 23)),
                                    "data-row": index,
                                    "data-col": 23
                                  }, null, 40, _hoisted_43), [
                                    [_vModelText, item.gun]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.jang) = $event),
                                    class: "table-input text-right",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 24)),
                                    "data-row": index,
                                    "data-col": 24
                                  }, null, 40, _hoisted_44), [
                                    [_vModelText, item.jang]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.go) = $event),
                                    class: "table-input text-right",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 25)),
                                    "data-row": index,
                                    "data-col": 25
                                  }, null, 40, _hoisted_45), [
                                    [_vModelText, item.go]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.sil) = $event),
                                    class: "table-input text-right",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 26)),
                                    "data-row": index,
                                    "data-col": 26
                                  }, null, 40, _hoisted_46), [
                                    [_vModelText, item.sil]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.san) = $event),
                                    class: "table-input text-right",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 27)),
                                    "data-row": index,
                                    "data-col": 27
                                  }, null, 40, _hoisted_47), [
                                    [_vModelText, item.san]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.sik) = $event),
                                    class: "table-input text-right",
                                    onKeydown: ($event: any) => (handleKeyDown($event, index, 28)),
                                    "data-row": index,
                                    "data-col": 28
                                  }, null, 40, _hoisted_48), [
                                    [_vModelText, item.sik]
                                  ])
                                ])
                              ]))
                            }), 128)),
                            _createElementVNode("tr", _hoisted_49, [
                              _hoisted_50,
                              _createElementVNode("td", _hoisted_51, _toDisplayString(formatNumber(calculateSum('base'))), 1),
                              _createElementVNode("td", _hoisted_52, _toDisplayString(formatNumber(calculateSum('overtime'))), 1),
                              _createElementVNode("td", _hoisted_53, _toDisplayString(formatNumber(calculateSum('night'))), 1),
                              _createElementVNode("td", _hoisted_54, _toDisplayString(formatNumber(calculateSum('holiday'))), 1),
                              _createElementVNode("td", _hoisted_55, _toDisplayString(formatNumber(calculateSum('dayOffPay'))), 1),
                              _createElementVNode("td", _hoisted_56, _toDisplayString(formatNumber(calculateSum('longTerm'))), 1),
                              _createElementVNode("td", _hoisted_57, _toDisplayString(formatNumber(calculateSum('sunim'))), 1),
                              _createElementVNode("td", _hoisted_58, _toDisplayString(formatNumber(calculateSum('bonus'))), 1),
                              _createElementVNode("td", _hoisted_59, _toDisplayString(formatNumber(calculateSum('eduPay'))), 1),
                              _createElementVNode("td", _hoisted_60, _toDisplayString(formatNumber(calculateSum('bojon'))), 1),
                              _createElementVNode("td", _hoisted_61, _toDisplayString(formatNumber(calculateSum('etc'))), 1),
                              _createElementVNode("td", _hoisted_62, _toDisplayString(formatNumber(calculateSum('dang'))), 1),
                              _createElementVNode("td", _hoisted_63, _toDisplayString(formatNumber(calculateSum('lunch'))), 1),
                              _createElementVNode("td", _hoisted_64, _toDisplayString(formatNumber(calculateSum('car'))), 1),
                              _createElementVNode("td", _hoisted_65, _toDisplayString(formatNumber(calculateSum('childcare'))), 1),
                              _createElementVNode("td", _hoisted_66, _toDisplayString(formatNumber(calculateSum('total'))), 1),
                              _createElementVNode("td", _hoisted_67, _toDisplayString(formatNumber(calculateSum('yeon'))), 1),
                              _createElementVNode("td", _hoisted_68, _toDisplayString(formatNumber(calculateSum('gun'))), 1),
                              _createElementVNode("td", _hoisted_69, _toDisplayString(formatNumber(calculateSum('jang'))), 1),
                              _createElementVNode("td", _hoisted_70, _toDisplayString(formatNumber(calculateSum('go'))), 1),
                              _createElementVNode("td", _hoisted_71, _toDisplayString(formatNumber(calculateSum('sil'))), 1),
                              _createElementVNode("td", _hoisted_72, _toDisplayString(formatNumber(calculateSum('san'))), 1),
                              _createElementVNode("td", _hoisted_73, _toDisplayString(formatNumber(calculateSum('sik'))), 1)
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("table", _hoisted_74, [
                          _hoisted_75,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calcData.value, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", _hoisted_76, _toDisplayString(item.empName || ''), 1),
                                _createElementVNode("td", _hoisted_77, _toDisplayString(item.empInOutStatus || ''), 1),
                                _createElementVNode("td", _hoisted_78, _toDisplayString(item.empJob || ''), 1),
                                _createElementVNode("td", _hoisted_79, _toDisplayString(item.empBirth || ''), 1),
                                _createElementVNode("td", _hoisted_80, _toDisplayString(item.empInDate || ''), 1),
                                _createElementVNode("td", _hoisted_81, _toDisplayString(item.base || 0), 1),
                                _createElementVNode("td", _hoisted_82, _toDisplayString(item.overtime || 0), 1),
                                _createElementVNode("td", _hoisted_83, _toDisplayString(item.night || 0), 1),
                                _createElementVNode("td", _hoisted_84, _toDisplayString(item.holiday || 0), 1),
                                _createElementVNode("td", _hoisted_85, _toDisplayString(item.dayOffPay || 0), 1),
                                _createElementVNode("td", _hoisted_86, _toDisplayString(item.longTerm || 0), 1),
                                _createElementVNode("td", _hoisted_87, _toDisplayString(item.sunim || 0), 1),
                                _createElementVNode("td", _hoisted_88, _toDisplayString(item.bonus || 0), 1),
                                _createElementVNode("td", _hoisted_89, _toDisplayString(item.eduPay || 0), 1),
                                _createElementVNode("td", _hoisted_90, _toDisplayString(item.bojon || 0), 1),
                                _createElementVNode("td", _hoisted_91, _toDisplayString(item.etc || 0), 1),
                                _createElementVNode("td", _hoisted_92, _toDisplayString(item.dang || 0), 1),
                                _createElementVNode("td", _hoisted_93, _toDisplayString(item.lunch || 0), 1),
                                _createElementVNode("td", _hoisted_94, _toDisplayString(item.car || 0), 1),
                                _createElementVNode("td", _hoisted_95, _toDisplayString(item.childcare || 0), 1),
                                _createElementVNode("td", _hoisted_96, _toDisplayString(item.total || 0), 1),
                                _createElementVNode("td", _hoisted_97, _toDisplayString(item.taxable || 0), 1),
                                _createElementVNode("td", _hoisted_98, _toDisplayString(item.usual || 0), 1),
                                _createElementVNode("td", _hoisted_99, _toDisplayString(item.minimum || 0), 1),
                                _createElementVNode("td", _hoisted_100, _toDisplayString(item.l_yeon || 0), 1),
                                _createElementVNode("td", _hoisted_101, _toDisplayString(item.l_gun || 0), 1),
                                _createElementVNode("td", _hoisted_102, _toDisplayString(item.l_jang || 0), 1),
                                _createElementVNode("td", _hoisted_103, _toDisplayString(item.l_go || 0), 1),
                                _createElementVNode("td", _hoisted_104, _toDisplayString(item.l_so || 0), 1),
                                _createElementVNode("td", _hoisted_105, _toDisplayString(item.l_ji || 0), 1),
                                _createElementVNode("td", _hoisted_106, _toDisplayString(item.l_jiwon || 0), 1),
                                _createElementVNode("td", _hoisted_107, _toDisplayString(item.l_sik || 0), 1),
                                _createElementVNode("td", _hoisted_108, _toDisplayString(item.l_etc || 0), 1),
                                _createElementVNode("td", _hoisted_109, _toDisplayString(item.l_yearEnd || 0), 1),
                                _createElementVNode("td", _hoisted_110, _toDisplayString(item.l_total || 0), 1),
                                _createElementVNode("td", _hoisted_111, _toDisplayString(item.c_yeon || 0), 1),
                                _createElementVNode("td", _hoisted_112, _toDisplayString(item.c_gun || 0), 1),
                                _createElementVNode("td", _hoisted_113, _toDisplayString(item.c_jang || 0), 1),
                                _createElementVNode("td", _hoisted_114, _toDisplayString(item.c_go || 0), 1),
                                _createElementVNode("td", _hoisted_115, _toDisplayString(item.c_sil || 0), 1),
                                _createElementVNode("td", _hoisted_116, _toDisplayString(item.c_san || 0), 1),
                                _createElementVNode("td", _hoisted_117, _toDisplayString(item.c_out || 0), 1),
                                _createElementVNode("td", _hoisted_118, _toDisplayString(item.c_total || 0), 1)
                              ]))
                            }), 128)),
                            _createElementVNode("tr", _hoisted_119, [
                              _hoisted_120,
                              _createElementVNode("td", _hoisted_121, _toDisplayString(formatNumber(calculateSumFromCalcData('base'))), 1),
                              _createElementVNode("td", _hoisted_122, _toDisplayString(formatNumber(calculateSumFromCalcData('overtime'))), 1),
                              _createElementVNode("td", _hoisted_123, _toDisplayString(formatNumber(calculateSumFromCalcData('night'))), 1),
                              _createElementVNode("td", _hoisted_124, _toDisplayString(formatNumber(calculateSumFromCalcData('holiday'))), 1),
                              _createElementVNode("td", _hoisted_125, _toDisplayString(formatNumber(calculateSumFromCalcData('dayOffPay'))), 1),
                              _createElementVNode("td", _hoisted_126, _toDisplayString(formatNumber(calculateSumFromCalcData('longTerm'))), 1),
                              _createElementVNode("td", _hoisted_127, _toDisplayString(formatNumber(calculateSumFromCalcData('sunim'))), 1),
                              _createElementVNode("td", _hoisted_128, _toDisplayString(formatNumber(calculateSumFromCalcData('bonus'))), 1),
                              _createElementVNode("td", _hoisted_129, _toDisplayString(formatNumber(calculateSumFromCalcData('eduPay'))), 1),
                              _createElementVNode("td", _hoisted_130, _toDisplayString(formatNumber(calculateSumFromCalcData('bojon'))), 1),
                              _createElementVNode("td", _hoisted_131, _toDisplayString(formatNumber(calculateSumFromCalcData('etc'))), 1),
                              _createElementVNode("td", _hoisted_132, _toDisplayString(formatNumber(calculateSumFromCalcData('dang'))), 1),
                              _createElementVNode("td", _hoisted_133, _toDisplayString(formatNumber(calculateSumFromCalcData('lunch'))), 1),
                              _createElementVNode("td", _hoisted_134, _toDisplayString(formatNumber(calculateSumFromCalcData('car'))), 1),
                              _createElementVNode("td", _hoisted_135, _toDisplayString(formatNumber(calculateSumFromCalcData('childcare'))), 1),
                              _createElementVNode("td", _hoisted_136, _toDisplayString(formatNumber(calculateSumFromCalcData('total'))), 1),
                              _createElementVNode("td", _hoisted_137, _toDisplayString(formatNumber(calculateSumFromCalcData('taxable'))), 1),
                              _createElementVNode("td", _hoisted_138, _toDisplayString(formatNumber(calculateSumFromCalcData('usual'))), 1),
                              _createElementVNode("td", _hoisted_139, _toDisplayString(formatNumber(calculateSumFromCalcData('minimum'))), 1),
                              _createElementVNode("td", _hoisted_140, _toDisplayString(formatNumber(calculateSumFromCalcData('l_yeon'))), 1),
                              _createElementVNode("td", _hoisted_141, _toDisplayString(formatNumber(calculateSumFromCalcData('l_gun'))), 1),
                              _createElementVNode("td", _hoisted_142, _toDisplayString(formatNumber(calculateSumFromCalcData('l_jang'))), 1),
                              _createElementVNode("td", _hoisted_143, _toDisplayString(formatNumber(calculateSumFromCalcData('l_go'))), 1),
                              _createElementVNode("td", _hoisted_144, _toDisplayString(formatNumber(calculateSumFromCalcData('l_so'))), 1),
                              _createElementVNode("td", _hoisted_145, _toDisplayString(formatNumber(calculateSumFromCalcData('l_ji'))), 1),
                              _createElementVNode("td", _hoisted_146, _toDisplayString(formatNumber(calculateSumFromCalcData('l_jiwon'))), 1),
                              _createElementVNode("td", _hoisted_147, _toDisplayString(formatNumber(calculateSumFromCalcData('l_sik'))), 1),
                              _createElementVNode("td", _hoisted_148, _toDisplayString(formatNumber(calculateSumFromCalcData('l_etc'))), 1),
                              _createElementVNode("td", _hoisted_149, _toDisplayString(formatNumber(calculateSumFromCalcData('l_yearEnd'))), 1),
                              _createElementVNode("td", _hoisted_150, _toDisplayString(formatNumber(calculateSumFromCalcData('l_total'))), 1),
                              _createElementVNode("td", _hoisted_151, _toDisplayString(formatNumber(calculateSumFromCalcData('c_yeon'))), 1),
                              _createElementVNode("td", _hoisted_152, _toDisplayString(formatNumber(calculateSumFromCalcData('c_gun'))), 1),
                              _createElementVNode("td", _hoisted_153, _toDisplayString(formatNumber(calculateSumFromCalcData('c_jang'))), 1),
                              _createElementVNode("td", _hoisted_154, _toDisplayString(formatNumber(calculateSumFromCalcData('c_go'))), 1),
                              _createElementVNode("td", _hoisted_155, _toDisplayString(formatNumber(calculateSumFromCalcData('c_sil'))), 1),
                              _createElementVNode("td", _hoisted_156, _toDisplayString(formatNumber(calculateSumFromCalcData('c_san'))), 1),
                              _createElementVNode("td", _hoisted_157, _toDisplayString(formatNumber(calculateSumFromCalcData('c_out'))), 1),
                              _createElementVNode("td", _hoisted_158, _toDisplayString(formatNumber(calculateSumFromCalcData('c_total'))), 1)
                            ])
                          ])
                        ]))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})